import css from "styled-jsx/css";

export default css`
  .histogram-sketelon {
    display: flex;
    width: 100%;
    height: auto;
    margin-bottom: 2rem;
    flex-direction: column;
    &--container {
      gap: 2.25rem;
      justify-content: center;
      display: flex;
      flex-direction: row;
      align-items: end;
      width: 100%;
      &--bar--small {
        width: 18px;
        height: 66px;
        border-radius: 16px;
      }
      &--bar--medium {
        width: 18px;
        height: 125px;
        border-radius: 16px;
      }
    }
  }
  .fadeOutBuyCardSkeleton {
    opacity: 1;
    animation: fadeOutAnimation 1s ease;
  }
  @keyframes fadeOutAnimation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
